<template>
<div class="about-course">
    <div class="container">
        <h2>Mon parcours /</h2>
        <ul v-html="course">
        </ul>
        <a 
            class="btn-cv"
            href="/CV_Pauline.pdf" 
            target="_blank"
            rel="noopener noreferrer"
            title="Télécharger mon CV"
          >
            <img  src="/picto_CV.svg" alt="Télécharger mon CV"/>
          </a>
    </div>
</div>
</template>

<script setup lang="ts">

    defineProps<{
        course:string
    }>()

</script>

<style lang="scss">
        .about-course{
            background-image: url("~/assets/imgs/fond_2.png");
            background-repeat: no-repeat;
            background-size: 150%;
            background-position: center center;
            padding: 50px 0;
                margin-top: 50px;
            h2{
                font-weight: 700;
                font-size: 20px;
                font-family: 'Open Sans',sans-serif;
                margin-bottom: 25px;
            }
            ul{
                text-align: center;
                list-style-type: none;
                padding: 0;
                li{
                    color: $text;
                    font-size: 18px;
                    &:not(:last-child){
                        margin-bottom: 10px;
                    }
                }
            }
            .btn-cv{
            display: block;
            margin-top: 40px;
            margin-inline: auto;
            width: 70px;
            transition: all .2s;
                &:hover{
                transform: rotate(10deg) scale(.9);
                }
            }
        }
</style>